<template>
<div class="pa-2">
    <v-card class="ma-1" outlined>
        <strong class="ma-3 mt-2 pb-4">
            Motivo da consulta
        </strong>
        <v-card-text>
            {{ anamnese.motivoConsulta }}
        </v-card-text>
        <!-- <v-text-field  readonly class="mx-4" outline v-model="anamnese.motivoConsulta"></v-text-field> -->
    </v-card>
    <v-card class="ma-2" outlined>
        <v-chip :color="anamnese.cigarro != 'NAO'? 'primary':''" class="ma-2" :disabled="anamnese.cigarro == 'NAO'">
            Fumante
        </v-chip>
        <v-chip :color="anamnese.bebidas != 'NAO'? 'primary':''" class="ma-2" :disabled="anamnese.bebidas == 'NAO'">
            Consome álcool
        </v-chip>
        <v-chip :color="anamnese.diabetes == 'SIM'? 'primary':''" class="ma-2" :disabled="anamnese.diabetes != 'SIM'">
            Diabético(a)
        </v-chip>
        <v-chip :color="anamnese.hipertensoHipotenso != 'NAO'? 'primary':''" class="ma-2" :disabled="anamnese.hipertensoHipotenso == 'NAO'">
            Hipertenso/hipotenso(a)
        </v-chip>
        <v-chip :color="anamnese.gravidez == 'SIM'? 'primary':''" class="ma-2" :disabled="anamnese.gravidez != 'SIM'">
            Gravidez
        </v-chip>
        <v-chip :color="anamnese.doencaFamiliar == 'SIM'? 'primary':''" class="ma-2" :disabled="anamnese.doencaFamiliar != 'SIM'">
            Histórico de doença
        </v-chip>
        <v-chip :color="anamnese.infectoContagiosa == 'SIM'? 'primary':''" class="ma-2" :disabled="anamnese.infectoContagiosa != 'SIM'">
            Infectocontagiosa
        </v-chip>
        <v-chip :color="anamnese.covid == 'SIM'? 'primary':''" class="ma-2" :disabled="anamnese.covid != 'SIM'">
            Teve Covid
        </v-chip>

    </v-card>
    <v-card class="ma-2" outlined v-show="anamnese.medicamentos">
        <strong class="ma-3 mt-2 pb-4">
            Medicamentos
        </strong>
        <v-card-text >
            <v-chip class="ma-2" v-for="(item, i) in anamnese.medicamentos" :key="i" color="success">
                {{ item.nome }}
            </v-chip>
        </v-card-text>
        <!-- <v-text-field  readonly class="mx-4" outline v-model="anamnese.motivoConsulta"></v-text-field> -->
    </v-card>

   <!--  <v-row>

       <v-col cols="12" md="6">
            <v-card class="ma-2" outlined v-show="anamnese.infectoContagiosa == 'SIM'">
                <strong :color="anamnese.infectoContagiosa == 'SIM'? 'primary':''" class="ma-2" :disabled="anamnese.covid != 'SIM'">
                    Infectocontagiosas
                </strong>
                <v-card-text>
                    {{ anamnese.descInfectoContagiosa }}
                </v-card-text>
                <!-- <v-text-field  readonly class="mx-4" outline v-model="anamnese.motivoConsulta"></v-text-field>
            </v-card>
        </v-col> -->
<!--
        <v-col cols="12" md="6">
            <v-card class="ma-2" outlined v-show="anamnese.doencaFamiliar == 'SIM'">
                <strong :color="anamnese.doencaFamiliar == 'SIM'? 'primary':''" class="ma-2" :disabled="anamnese.covid != 'SIM'">
                    Histórico de doença
                </strong>

                <v-card-text>
                    {{ anamnese.descDoencaFamiliar }}
                </v-card-text>
            </v-card>
        </v-col>
    </v-row> -->

    <v-card class="ma-2" outlined>
        <strong class="ma-4 mt-2 pb-4">
            Paciente alega não ter realizado os exames abaixo:
        </strong>
        <br/>
        <v-chip :color="anamnese.examesLaboratoriais == 'NAO'? 'error': ''" class="ma-2" :disabled="anamnese.examesLaboratoriais != 'NAO'">
            Exames laboratório
        </v-chip>

        <v-chip :color="anamnese.abdomenTotal == 'NAO'? 'error': ''" class="ma-2" :disabled="anamnese.abdomenTotal != 'NAO'">
            USG abdômen total
        </v-chip>
        <v-chip :color="anamnese.cardiologico == 'NAO'? 'error': ''" class="ma-2" :disabled="anamnese.cardiologico != 'NAO'">
            Exames cardiológicos
        </v-chip>
        <v-chip :color="anamnese.genecologico == 'NAO'? 'error': ''" class="ma-2" :disabled="anamnese.genecologico != 'NAO'">
            Exames ginecológicos
        </v-chip>
        <v-chip :color="anamnese.mamografia == 'NAO'? 'error': ''" class="ma-2" :disabled="anamnese.mamografia != 'NAO'">
            Mamografia
        </v-chip>
        <v-chip :color="anamnese.urologico == 'NAO'? 'error': ''" class="ma-2" :disabled="anamnese.urologico != 'NAO'">
            Exames urológicos
        </v-chip>

    </v-card>
    <v-card class="ma-2 pa-2" outlined>
        <v-layout row wrap>

            <v-flex xs2>
                <v-text-field label="PA X mmHg" readonly outlined class="mx-1" outline v-model="anamnese.pax"></v-text-field>
            </v-flex>
            <v-flex xs2>
                <v-text-field label="Frequência Cardíaca" readonly outlined class="mx-1" outline v-model="anamnese.frequenciaCardiaca"></v-text-field>
            </v-flex>
            <!-- <v-flex xs2>
                <v-text-field label="Temperatura" readonly outlined class="mx-1" outline v-model="anamnese.temperatura"></v-text-field>
            </v-flex> -->
            <v-flex xs2>
                <v-text-field label="HGT mg/dl" readonly outlined class="mx-1" outline v-model="anamnese.hgt"></v-text-field>
            </v-flex>
            <v-flex xs2>
                <v-text-field label="Spo2" readonly outlined class="mx-1" outline v-model="anamnese.sop2"></v-text-field>
            </v-flex>
        </v-layout>
    </v-card>
</div>

</template>

<script>
import medicoService from '../../services/medico.service'

export default {

  name: 'anamnese',
  props: {
    idAtendimento: {
      type: Number
    }
  },
  data () {
    return {
      yesNoOptions: [{
        nome: 'SIM',
        id: 'SIM'
      },
      {
        nome: 'NÃO',
        id: 'NAO'
      },
      {
        nome: 'SIM / FAZ ACOMPANHAMENTO',
        id: 'SIMACOMPANHAMENTO'
      },
      {
        nome: 'SIM / NÃO FAZ ACOMPANHAMENTO',
        id: 'NAOACOMPANHAMENTO'
      },
      {
        nome: 'HIPERTENSO',
        id: 'HIPERTENSAO'
      },
      {
        nome: 'HIPOTENSO',
        id: 'HIPOTENSAO'
      },
      {
        nome: 'FREQUENTEMENTE',
        id: 'FREQUENTEMENTE'
      },
      {
        nome: 'OCASIONALMENTE',
        id: 'OCASIONALMENTE'
      },
      {
        nome: 'SIM / FAZ ACOMPANHAMENTO',
        id: 'SIMACOMPANHAMENTO'
      }
      ],

      anamnese: {
        motivoConsulta: '',
        cigarro: '',
        bebidas: '',
        diabetes: '',
        hipertensoHipotenso: '',
        infectoContagiosa: '',
        descInfectoContagiosa: '',
        gravidez: '',
        doencaFamiliar: '',
        descDoencaFamiliar: '',
        cancerFamilia: '',
        descCancerFamiliar: '',
        usoDeMedicacao: '',
        medicamentos: [],
        cirurgia: '',
        descCirurgia: '',
        covid: '',
        examesLaboratoriais: '',
        abdomenTotal: '',
        cardiologico: '',
        genecologico: '',
        mamografia: '',
        descMamografia: '',
        urologico: '',
        pax: '',
        frequenciaCardiaca: '',
        temperatura: '',
        hgt: '',
        sop2: ''
      }
    }
  },
  methods: {
    buscarAnamnese () {
      // console.log('idAtendimento --> ', this.idAtendimento);
      console.log('<-----------')
      medicoService.medico.buscarAnamnese(this.idAtendimento).then(r => {
        console.log('----------', r.status)
        if (r.status == 200) {
          this.anamnese = r.data
          console.log('ANAMNESE', r.data)
        }
      })
    }
  },
  mounted () {
    this.buscarAnamnese()
  }
}
</script>

<style scoped>
.form-group {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

label {
    width: 50%;
    font-weight: bold;
    margin-bottom: 5px;
}

input {
    width: 45%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
}
</style>
